export default "__VITE_ASSET__Bb2T33HT__"